import { BillingAccountRelatedMeterResponse, GetMonthlyInvoicePeriodDtoMeter } from '@eneco/dc-be/client';
import { useContent } from '@sitecore/common';
import { MyEnecoInvoiceBillingDetailsRendering } from '@sitecore/types/MyEnecoInvoiceBillingDetails';

import ReadFormField from '../../../../../components/ReadFormField';
import { getBillingAccountLabel } from '../utils/getBillingAccountLabel';

export const BillingDetailsReadFormField = ({
  meters,
  value,
}: {
  meters: GetMonthlyInvoicePeriodDtoMeter[] | BillingAccountRelatedMeterResponse[];
  value: string | undefined;
}) => {
  const { fields } = useContent<MyEnecoInvoiceBillingDetailsRendering>();
  const { eanLabel, consumptionTypesList } = fields.billingDetails;

  if (consumptionTypesList && eanLabel) {
    const label = getBillingAccountLabel({ consumptionTypesList, meters, eanLabel });
    return <ReadFormField label={label} value={value} />;
  }

  return null;
};
